export const GET_NOTES = "GET_NOTES";
export const GET_NOTES_IN_TRASH = "GET_NOTES_IN_TRASH";
export const MOVE_TO_TRASH = "MOVE_TO_TRASH";
export const ADD_NOTE = "ADD_NOTE";
export const SET_LOADING = "SET_LOADING";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const DELETE_NOTE = "DELETE_NOTE";
export const RESTORE_NOTE = "RESTORE_NOTE";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const NOTE_ERROR = "NOTE_ERROR";
